interface State {
  editMode: boolean;
  saving: boolean;
}

export const useEditorStore = defineStore("editor", {
  state: (): State => ({
    editMode: false,
    saving: false,
  }),
});
